module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.profile !== null) ? _c('div', {
    staticClass: "grid",
    attrs: {
      "id": "user-board"
    }
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('div', {
    staticClass: "grid-1"
  }, [_c('h2', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.profile.name))])]), _vm._v(" "), _c('div', {
    staticClass: "grid-1"
  }, [_c('ul', {
    staticClass: "col"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": ("/profile/" + (_vm.profile.uid) + "/")
    }
  }, [_vm._v("Profile")])], 1), _vm._v(" "), _c('li', [(_vm.identity !== null && _vm.profile.uid === _vm.identity.uid) ? _c('router-link', {
    attrs: {
      "to": "/profile/setting"
    }
  }, [_vm._v("Settings")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "grid-1"
  }, [_c('table', {
    staticClass: "col"
  }, [_c('tr', {
    staticClass: "grid"
  }, [_c('td', {
    staticClass: "col"
  }, [_vm._v("Category")]), _vm._v(" "), _c('td', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.getCategory(_vm.profile.category)))])]), _vm._v(" "), (_vm.profile.rate !== undefined) ? _c('tr', {
    staticClass: "grid"
  }, [_c('td', {
    staticClass: "col"
  }, [_vm._v("Rate")]), _vm._v(" "), _c('td', {
    staticClass: "col"
  }, [_vm._v(_vm._s(_vm.profile.rate))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    attrs: {
      "profile": _vm.profile
    }
  })], 1)], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-673e247c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/UserBoard.vue
// module id = 588
// module chunks = 0